/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Input,
  List,
  Radio,
  Row,
  Spin,
  Tag,
  Typography,
} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../layouts/User';
import styles from './index.module.scss';
import { LoadingOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { BASE_URL, DEFAULT_PRODUCT_URL } from '../../config';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { convertPrice } from '../../utils/display';
import { useNavigate } from 'react-router-dom';

const { Text, Paragraph } = Typography;
const { Search } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SearchProduct: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('keyword');
  const lat = searchParams.get('lat');
  const long = searchParams.get('long');
  const postalCode = searchParams.get('postal_code');
  const user = searchParams.get('user');
  const promo = searchParams.get('promo');

  const [products, setProducts] = useState<any>([]);
  const [hasProducts, setHasProducts] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [skip, setSkip] = useState<number>(1);
  const [postalCodeQuery, setPostalCodeQuery] = useState<string>('');
  const [disable, setDisable] = useState<boolean>(true);
  const [hidden, setHidden] = useState<boolean>(true);
  const [isFetchedShop, setIsFetchedShop] = useState(false);

  const limit = 10;

  const getProductSearch = async () => {
    if (loading) return;
    setLoading(true);
    const url = `${BASE_URL}/shops/product/search?lat=${lat}&long=${long}&postal_code=${postalCodeQuery}&search=${search}&skip=${skip}&limit=${limit}&promo=${
      promo ? promo : ''
    }&user=${user ? user : ''}`;
    const response = await axios.get(url);
    const shops = response.data.shops;

    if (shops.length < limit) {
      setHasProducts(false);
    }

    const promotionProducts = await findPromotionTag(shops);

    let result = [];
    result = shops.map((shopItem: any) => ({
      ...shopItem,
      ...promotionProducts.find(
        (pp: any) =>
          pp.sellerCode === shopItem.code &&
          pp.productCode === shopItem.userProducts.product.code
      ),
    }));

    if (user) {
      const shopMembers = await findShopMember(shops);
      result = result.map((shopItem: any) => ({
        ...shopItem,
        ...shopMembers.find((sm: any) => sm.shopId === shopItem._id),
      }));
    }

    setProducts([...products, ...result]);
    setSkip(skip + 1);
    setLoading(false);
    setDisable(false);

    if (result.length === 0 && !isFetchedShop) {
      setHidden(true);
    } else {
      if (postalCode) {
        setHidden(false);
      } else {
        setHidden(true);
      }
    }

    setIsFetchedShop(true);
  };

  const findPromotionTag = async (shopData: any) => {
    const url = '/promotions/sellerProducts';
    const prepareSellerProducts = [];
    for (const item of shopData) {
      if (item.userProducts.product.code) {
        prepareSellerProducts.push({
          sellerCode: item.code,
          productCode: item.userProducts.product.code,
        });
      }
    }

    const { data } = await axios.post(url, {
      sellerProducts: prepareSellerProducts,
    });
    return data;
  };

  const findShopMember = async (shopData: any) => {
    const url = `${BASE_URL}/shop-buyer/shop-buyer-member-multiple/${user}`;
    const prepareShops = shopData.map((item: any) => item._id);

    const { data } = await axios.post(url, { shops: prepareShops });
    return data.shops;
  };

  const changeByArea = async (value: string) => {
    setProducts([]);
    setSkip(1);
    setHasProducts(true);

    if (value === 'area') {
      setPostalCodeQuery(`${postalCode}`);
    } else if (value === 'all') {
      setPostalCodeQuery('');
    }
  };

  const searchProduct = async (value: any) => {
    if (value && value !== search) {
      setIsFetchedShop(false);
      setProducts([]);
      setSkip(1);
      setHasProducts(true);
      setSearch(value);

      navigate(
        `/search?keyword=${value}&lat=${lat}&long=${long}&postal_code=${postalCode}&user=${
          user ? user : ''
        }&promo=${promo ? promo : ''}`
      );
    }
  };

  const addDefaultImage = async (ev: any) => {
    if (!ev.target.errored) {
      ev.target.errored = true;
      ev.target.src = DEFAULT_PRODUCT_URL;
    }
  };

  useEffect(() => {
    if (search) {
      getProductSearch();
    }
  }, [search, postalCodeQuery]);

  useEffect(() => {
    if (keyword) {
      setSearch(keyword);
    }
  }, [keyword]);

  const ProductList = () => {
    return (
      <>
        <Row>
          <Col span={24}>
            <InfiniteScroll
              dataLength={products.length}
              next={getProductSearch}
              hasMore={hasProducts}
              loader={
                <div
                  className={styles.textCenter}
                  style={{
                    marginTop: '30px',
                    marginBottom: '30px',
                    fontSize: '14px',
                  }}
                >
                  <Spin indicator={antIcon} />
                  &nbsp;&nbsp;กำลังโหลดรายการสินค้า
                </div>
              }
              className={styles.infiniteScrollWrapper}
              style={{ overflow: 'unset' }}
            >
              <List
                grid={{
                  gutter: 10,
                  xs: 2,
                  sm: 3,
                  md: 4,
                  lg: 4,
                  xl: 6,
                  xxl: 6,
                  column: 6,
                }}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description='ไม่พบผลการค้นหา'
                    />
                  ),
                }}
                dataSource={products}
                renderItem={(item: any) => (
                  <List.Item key={item._id} style={{ marginBottom: '10px' }}>
                    <Link
                      to={`/shops/product-detail/?id=${item.userProducts._id}`}
                    >
                      <Card
                        hoverable
                        className={styles.productItem}
                        bodyStyle={{
                          padding: '7px 0 0 0',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'baseline',
                        }}
                        cover={
                          <img
                            alt='product'
                            src={
                              item.userProducts.product.files.length
                                ? item.userProducts.product.files[0]
                                : DEFAULT_PRODUCT_URL
                            }
                            onError={async (e) => {
                              await addDefaultImage(e);
                            }}
                          />
                        }
                      >
                        <Paragraph
                          ellipsis={{ rows: 3, symbol: '...' }}
                          style={{
                            height: '66px',
                            marginBottom: 0,
                            padding: '0 10px',
                          }}
                        >
                          {item.userProducts.product.productName}
                        </Paragraph>

                        {item.hasPromotion ? (
                          <Tag
                            color='#d4380d'
                            style={{
                              fontSize: '10px',
                              lineHeight: '18px',
                              marginLeft: '10px',
                            }}
                          >
                            ร่วมโปรโมชั่น
                          </Tag>
                        ) : (
                          <div style={{ height: '20px' }}>&nbsp;</div>
                        )}

                        <div className={styles.antTextSecondary}>
                          <strong>
                            ฿&nbsp;
                            {item.isMember ? (
                              <>
                                {convertPrice(item.userProducts.memberPrice)}
                                <div className={styles.productPriceBefore}>
                                  {convertPrice(item.userProducts.price)}
                                </div>
                              </>
                            ) : (
                              <>
                                {convertPrice(item.userProducts.price)}
                                <div style={{ height: '14px' }}>&nbsp;</div>
                              </>
                            )}
                          </strong>
                        </div>

                        <div className={styles.productItemFooter}>
                          <Paragraph
                            ellipsis={{ rows: 1, symbol: '...' }}
                            className={styles.shopName}
                          >
                            <span>ขายโดย:</span> {item.name}
                          </Paragraph>
                          <div className={styles.shopDistance}>
                            <span>{item.distCalculated.toFixed(1)} กม.</span>
                          </div>
                        </div>
                      </Card>
                    </Link>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <Layout>
        {user !== 'undefined' && (
          <>
            <div className={styles.header}>
              <Text strong className={`${styles.buttonLink} ${styles.active}`}>
                หน้าแรก
              </Text>
              <Link to='/promotions' className={styles.buttonLink}>
                <Text>โปรโมชั่นสำหรับคุณ</Text>
              </Link>
            </div>
            <Divider className={styles.divider} />
          </>
        )}

        <Row>
          <Col xs={12} lg={24}>
            <div className={styles.filterText}>ค้นหาสินค้า</div>
          </Col>

          <Col xs={12} md={0}>
            <Link to='/product-categories'>
              <Button
                className={styles.catText}
                shape='round'
                icon={<UnorderedListOutlined />}
                size='small'
              >
                หมวดหมู่
              </Button>
            </Link>
          </Col>

          <Col xs={24} lg={24}>
            <Search
              className={styles.searchInput}
              placeholder='ค้นหาสินค้าที่คุณต้องการ'
              onSearch={searchProduct}
              enterButton
              defaultValue={`${keyword}`}
              disabled={disable}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={5}>
            <div
              className={`${styles.filterText} ${styles.recommend}`}
              style={{ display: disable === true ? 'none' : 'flex' }}
            >
              {promo ? 'ผลการค้นหาจากโปรโมชั่น' : 'ผลการค้นหา'}
            </div>
          </Col>

          <Col xs={19}>
            <div
              className={`${styles.filterText} ${styles.recommend} ${styles.option}`}
              style={{ display: hidden === true ? 'none' : 'flex' }}
            >
              <div>แสดงสินค้า</div>
              <Radio.Group
                onChange={(e) => changeByArea(e.target.value)}
                defaultValue='all'
                buttonStyle='solid'
                disabled={disable}
              >
                <Radio.Button
                  value='all'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>ทั้งหมด</span>
                </Radio.Button>
                <Radio.Button
                  value='area'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>อยู่ในพื้นที่จัดส่ง</span>
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>

        {ProductList()}
      </Layout>
    </>
  );
};

export default SearchProduct;
